module.exports = __webpack_public_path__ + "img/02_noff_open_L1.7c530905.svg";